
export default function IndustriesSection() {
  const industries = [
    {
      name: "Manufacturing",
      description: "Assembly lines, quality control, and material handling automation",
      icon: "ri-settings-3-line",
      image: "https://public.readdy.ai/ai/img_res/8adffacf0bc89e0123fa95ca63bc1c73.jpg"
    },
    {
      name: "Logistics & 3PL",
      description: "Warehouse automation, order fulfillment, and inventory management",
      icon: "ri-truck-line",
      image: "https://readdy.ai/api/search-image?query=Large%20logistics%20warehouse%20with%20robotic%20forklifts%2C%20automated%20storage%20systems%2C%20workers%20with%20safety%20gear%2C%20modern%203PL%20facility%2C%20efficient%20material%20flow%2C%20industrial%20automation&width=300&height=200&seq=logistics-001&orientation=landscape"
    },
    {
      name: "Retail Distribution",
      description: "Automated sorting, packaging, and distribution center operations",
      icon: "ri-store-line",
      image: "https://readdy.ai/api/search-image?query=Retail%20distribution%20center%20with%20automated%20sorting%20systems%2C%20robotic%20packaging%20equipment%2C%20workers%20in%20safety%20vests%2C%20modern%20fulfillment%20center%2C%20e-commerce%20logistics%20automation&width=300&height=200&seq=retail-001&orientation=landscape"
    },
    {
      name: "Electronics",
      description: "Precision assembly, testing, and clean room operations",
      icon: "ri-computer-line",
      image: "https://readdy.ai/api/search-image?query=Electronics%20manufacturing%20clean%20room%20with%20precision%20robotic%20assembly%2C%20workers%20in%20clean%20suits%2C%20high-tech%20semiconductor%20or%20electronics%20production%2C%20sterile%20industrial%20environment%2C%20advanced%20automation&width=300&height=200&seq=electronics-001&orientation=landscape"
    }
  ];

  return (
    <section id="industries" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Industries We Serve</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Proven robotics solutions deployed across diverse industrial sectors, 
            each tailored to specific operational requirements and safety standards.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {industries.map((industry, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 group-hover:-translate-y-2">
                <div className="h-40 bg-gray-100 relative overflow-hidden">
                  <img 
                    src={industry.image} 
                    alt={industry.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-white/90 rounded-lg">
                      <i className={`${industry.icon} text-blue-600 text-lg`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{industry.name}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{industry.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
